import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor( private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const isRefreshTokenRequest = request.url.includes('/refresh-token');
    const accessToken = this.authService.getAccessToken();

    if (accessToken && !isRefreshTokenRequest) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) { // Assuming 401 is the "Unauthorized" status code
          return this.authService.refreshToken().pipe(
            switchMap(() => {
              const newAccessToken = this.authService.getAccessToken();
              if (newAccessToken) {
                request = request.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newAccessToken}`
                  }
                });
                return next.handle(request); // Retry the request with the new token
              } else {
                this.authService.logout();
                return throwError(() => new Error("Session expired, please login"));
              }
            }),
            catchError(() => {
              this.authService.logout();
              return throwError(() => new Error("Session expired, please login"));
            })
          );
        } else {
          return throwError(() => error);
        }
      })
    );
  }
}
